export const uz = {
    'home': 'Asosiy',
    'tours': 'Turlar',
    'services' : 'Xizmatlar',
    'blogs' : 'Bloglar',
    'about' : 'Biz haqimizda',
    'contact' : 'Aloqalar',
    'to_usa' : "Amerika Qo'shma Shtatlariga",
    'to_thailand' : "Tailandga",
    'to_europe' : "Yevropaga",
    'to_dubai' : 'Dubayga',
    'to_egypt' : "Misrga",
    'to_malasia' : "Malaysiyaga",
    'home_icon1' : "Ajoyib sayohat",
    'home_icon1-txt' : "Toshkendan eng foydali va qiziqarli turlar, bizda butun dunyo boylab byudjetli sayohatlar mavjud va sizga noyob imkoniyat beradi...",
    "home_icon2" : "Kruizda sayohat",
    'home_icon2-txt' : "Eng yaxshi va ajoyib Kruiz sayohatlari. shuningdek turli yonalishdagi Dengiz sayohatlari...",
    'home_icon3' : "Transport xizmatlari",
    'home_icon3-txt' : "Biz transport xizmatlari va shaharlar boylab sayohat qilish uchun keng turdagi transport xizmatlarini taklif qilamiza...",
    'home_icon4' : "Imkoniyatliy viza olish",
    'home_icon4-txt' : "Biz maksimal samaradorlik bilan boshqa davlatga viza olishga yordam beramiz. Professional vizalarni qollab-quvvatlash va biz siz uchun vizalarni qollab-quvvatlash boyicha eng maqul takliflarni bera olamiz..",
    'home_cards-title' : "Dunyo boylab turlar",
    'home_cards-txt' : "Byudjet turlari / Individual turlari / Oilaviy turlari"
}